// extracted by mini-css-extract-plugin
export default {"recos":"x5-z","productCardOverride":"y5-z","rowHasBadge":"z5-z"};